module.exports = __webpack_public_path__ + "static/rocks-e9418eb0d92353d0124e941f16f34832.jpg";